// actionTypes.js

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';
export const CREATE_PROPERTY_SUCCESS = 'CREATE_PROPERTY_SUCCESS';
export const CREATE_PROPERTY_FAIL = 'CREATE_PROPERTY_FAIL';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAIL = 'GET_ALL_USERS_FAIL';
export const UPDATE_MAP_LOCATION = 'UPDATE_MAP_LOCATION';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAIL = 'UPLOAD_IMAGE_FAIL';
export const GET_PROPERTIES_BY_SELLER_ID_SUCCESS = 'GET_PROPERTIES_BY_SELLER_ID_SUCCESS';
export const GET_PROPERTIES_BY_SELLER_ID_FAIL = 'GET_PROPERTIES_BY_SELLER_ID_FAIL';
export const EDIT_PROPERTY_REQUEST = 'EDIT_PROPERTY_REQUEST';
export const EDIT_PROPERTY_SUCCESS = 'EDIT_PROPERTY_SUCCESS';
export const EDIT_PROPERTY_FAIL = 'EDIT_PROPERTY_FAIL';
export const GET_PROPERTY_BY_ID = 'GET_PROPERTY_BY_ID';
export const GET_PROPERTIES_PENDING_SUCCESS = 'GET_PROPERTIES_PENDING_SUCCESS';
export const GET_PROPERTIES_PENDING_FAIL = 'GET_PROPERTIES_PENDING_FAIL';
export const GET_PROPERTIES_LIST_SUCCESS = 'GET_PROPERTIES_LIST_SUCCESS';
export const GET_PROPERTIES_LIST_FAIL = 'GET_PROPERTIES_LIST_FAIL';
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';
export const GET_ALL_SELLERS_SUCCESS = 'GET_ALL_SELLERS_SUCCESS';
export const GET_ALL_SELLERS_FAIL = 'GET_ALL_SELLERS_FAIL';
export const UPDATE_SELLER_SUCCESS = 'UPDATE_SELLER_SUCCESS';
export const UPDATE_SELLER_FAIL = 'UPDATE_SELLER_FAIL';
export const UPDATE_SELLER_REQUEST = 'UPDATE_SELLER_REQUEST';
export const CREATE_VISITA_REQUEST = 'CREATE_VISITA_REQUEST';
export const CREATE_VISITA_SUCCESS = 'CREATE_VISITA_SUCCESS';
export const CREATE_VISITA_FAIL = 'CREATE_VISITA_FAIL';
export const GET_ALL_VISITAS_REQUEST = 'GET_ALL_VISITAS_REQUEST';
export const GET_ALL_VISITAS_SUCCESS = 'GET_ALL_VISITAS_SUCCESS';
export const GET_ALL_VISITAS_FAIL = 'GET_ALL_VISITAS_FAIL';
export const GET_VISITAS_BY_PROPERTY_REQUEST = 'GET_VISITAS_BY_PROPERTY_REQUEST';
export const GET_VISITAS_BY_PROPERTY_SUCCESS = 'GET_VISITAS_BY_PROPERTY_SUCCESS';
export const GET_VISITAS_BY_PROPERTY_FAIL = 'GET_VISITAS_BY_PROPERTY_FAIL';
export const GET_PROPERTIES_BY_SELLER = 'GET_PROPERTIES_BY_SELLER';
export const GET_PROPERTIES_BY_SELLER_ERROR = 'GET_PROPERTIES_BY_SELLER_ERROR';
export const GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS = 'GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS';
export const GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL = 'GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL';
export const FETCH_RENTALS_REQUEST = 'FETCH_RENTALS_REQUEST';
export const FETCH_RENTALS_SUCCESS = 'FETCH_RENTALS_SUCCESS';
export const FETCH_RENTALS_FAILURE = 'FETCH_RENTALS_FAILURE';
export const FETCH_RENTAL_REQUEST = 'FETCH_RENTAL_REQUEST';
export const FETCH_RENTAL_SUCCESS = 'FETCH_RENTAL_SUCCESS';
export const FETCH_RENTAL_FAILURE = 'FETCH_RENTAL_FAILURE';
export const CREATE_RENTAL_REQUEST = 'CREATE_RENTAL_REQUEST';
export const CREATE_RENTAL_SUCCESS = 'CREATE_RENTAL_SUCCESS';
export const CREATE_RENTAL_FAILURE = 'CREATE_RENTAL_FAILURE';
export const UPDATE_RENTAL_REQUEST = 'UPDATE_RENTAL_REQUEST';
export const UPDATE_RENTAL_SUCCESS = 'UPDATE_RENTAL_SUCCESS';
export const UPDATE_RENTAL_FAILURE = 'UPDATE_RENTAL_FAILURE';
export const DELETE_RENTAL_REQUEST = 'DELETE_RENTAL_REQUEST';
export const DELETE_RENTAL_SUCCESS = 'DELETE_RENTAL_SUCCESS';
export const DELETE_RENTAL_FAILURE = 'DELETE_RENTAL_FAILURE';

// Nuevos tipos de acción para propiedades cerradas
export const GET_CLOSED_PROPERTIES_REQUEST = 'GET_CLOSED_PROPERTIES_REQUEST';
export const GET_CLOSED_PROPERTIES_SUCCESS = 'GET_CLOSED_PROPERTIES_SUCCESS';
export const GET_CLOSED_PROPERTIES_FAIL = 'GET_CLOSED_PROPERTIES_FAIL';

export const SESSION_STARTED = 'SESSION_STARTED';
export const SESSION_ENDED = 'SESSION_ENDED';
export const SESSION_HISTORY_SUCCESS = 'SESSION_HISTORY_SUCCESS';
export const SESSION_HISTORY_FAIL = 'SESSION_HISTORY_FAIL';
export const SESSION_MONTHLY_SUCCESS = 'SESSION_MONTHLY_SUCCESS';
export const SESSION_MONTHLY_FAIL = 'SESSION_MONTHLY_FAIL';

export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAIL = 'FETCH_EVENTS_FAIL';

export const CREATE_EVENT_REQUEST = 'CREATE_EVENT_REQUEST';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAIL = 'CREATE_EVENT_FAIL';

export const UPDATE_EVENT_REQUEST = 'UPDATE_EVENT_REQUEST';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAIL = 'UPDATE_EVENT_FAIL';

export const DELETE_EVENT_REQUEST = 'DELETE_EVENT_REQUEST';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAIL = 'DELETE_EVENT_FAIL';

// Client action types
export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST';
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS';
export const CREATE_CLIENT_FAIL = 'CREATE_CLIENT_FAIL';

export const GET_CLIENTS_BY_SELLER_REQUEST = 'GET_CLIENTS_BY_SELLER_REQUEST';
export const GET_CLIENTS_BY_SELLER_SUCCESS = 'GET_CLIENTS_BY_SELLER_SUCCESS';
export const GET_CLIENTS_BY_SELLER_FAIL = 'GET_CLIENTS_BY_SELLER_FAIL';

export const GET_ALL_CLIENTS_REQUEST = 'GET_ALL_CLIENTS_REQUEST';
export const GET_ALL_CLIENTS_SUCCESS = 'GET_ALL_CLIENTS_SUCCESS';
export const GET_ALL_CLIENTS_FAIL = 'GET_ALL_CLIENTS_FAIL';

export const GET_CLIENT_BY_ID_REQUEST = 'GET_CLIENT_BY_ID_REQUEST';
export const GET_CLIENT_BY_ID_SUCCESS = 'GET_CLIENT_BY_ID_SUCCESS';
export const GET_CLIENT_BY_ID_FAIL = 'GET_CLIENT_BY_ID_FAIL';

export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const UPDATE_CLIENT_FAIL = 'UPDATE_CLIENT_FAIL';

export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAIL = 'DELETE_CLIENT_FAIL';

export const ASSOCIATE_CLIENT_PROPERTY_REQUEST = 'ASSOCIATE_CLIENT_PROPERTY_REQUEST';
export const ASSOCIATE_CLIENT_PROPERTY_SUCCESS = 'ASSOCIATE_CLIENT_PROPERTY_SUCCESS';
export const ASSOCIATE_CLIENT_PROPERTY_FAIL = 'ASSOCIATE_CLIENT_PROPERTY_FAIL';

export const GET_CLIENTS_BY_PROPERTY_REQUEST = 'GET_CLIENTS_BY_PROPERTY_REQUEST';
export const GET_CLIENTS_BY_PROPERTY_SUCCESS = 'GET_CLIENTS_BY_PROPERTY_SUCCESS';
export const GET_CLIENTS_BY_PROPERTY_FAIL = 'GET_CLIENTS_BY_PROPERTY_FAIL';

// ================ RENTAL MANAGEMENT ACTION TYPES ================

// Dashboard y vistas generales
export const FETCH_RENTAL_DASHBOARD_REQUEST = 'FETCH_RENTAL_DASHBOARD_REQUEST';
export const FETCH_RENTAL_DASHBOARD_SUCCESS = 'FETCH_RENTAL_DASHBOARD_SUCCESS';
export const FETCH_RENTAL_DASHBOARD_FAIL = 'FETCH_RENTAL_DASHBOARD_FAIL';

export const FETCH_ACTIVE_RENTALS_REQUEST = 'FETCH_ACTIVE_RENTALS_REQUEST';
export const FETCH_ACTIVE_RENTALS_SUCCESS = 'FETCH_ACTIVE_RENTALS_SUCCESS';
export const FETCH_ACTIVE_RENTALS_FAIL = 'FETCH_ACTIVE_RENTALS_FAIL';

export const FETCH_RENTAL_DETAIL_REQUEST = 'FETCH_RENTAL_DETAIL_REQUEST';
export const FETCH_RENTAL_DETAIL_SUCCESS = 'FETCH_RENTAL_DETAIL_SUCCESS';
export const FETCH_RENTAL_DETAIL_FAIL = 'FETCH_RENTAL_DETAIL_FAIL';

export const FETCH_OVERDUE_PAYMENTS_REQUEST = 'FETCH_OVERDUE_PAYMENTS_REQUEST';
export const FETCH_OVERDUE_PAYMENTS_SUCCESS = 'FETCH_OVERDUE_PAYMENTS_SUCCESS';
export const FETCH_OVERDUE_PAYMENTS_FAIL = 'FETCH_OVERDUE_PAYMENTS_FAIL';

export const FETCH_EXPIRING_CONTRACTS_REQUEST = 'FETCH_EXPIRING_CONTRACTS_REQUEST';
export const FETCH_EXPIRING_CONTRACTS_SUCCESS = 'FETCH_EXPIRING_CONTRACTS_SUCCESS';
export const FETCH_EXPIRING_CONTRACTS_FAIL = 'FETCH_EXPIRING_CONTRACTS_FAIL';

// Gestión de pagos/cuotas
export const GENERATE_PAYMENT_SCHEDULE_REQUEST = 'GENERATE_PAYMENT_SCHEDULE_REQUEST';
export const GENERATE_PAYMENT_SCHEDULE_SUCCESS = 'GENERATE_PAYMENT_SCHEDULE_SUCCESS';
export const GENERATE_PAYMENT_SCHEDULE_FAIL = 'GENERATE_PAYMENT_SCHEDULE_FAIL';

export const FETCH_RENTAL_PAYMENTS_REQUEST = 'FETCH_RENTAL_PAYMENTS_REQUEST';
export const FETCH_RENTAL_PAYMENTS_SUCCESS = 'FETCH_RENTAL_PAYMENTS_SUCCESS';
export const FETCH_RENTAL_PAYMENTS_FAIL = 'FETCH_RENTAL_PAYMENTS_FAIL';

export const REGISTER_PAYMENT_REQUEST = 'REGISTER_PAYMENT_REQUEST';
export const REGISTER_PAYMENT_SUCCESS = 'REGISTER_PAYMENT_SUCCESS';
export const REGISTER_PAYMENT_FAIL = 'REGISTER_PAYMENT_FAIL';

export const UPDATE_OVERDUE_PAYMENTS_REQUEST = 'UPDATE_OVERDUE_PAYMENTS_REQUEST';
export const UPDATE_OVERDUE_PAYMENTS_SUCCESS = 'UPDATE_OVERDUE_PAYMENTS_SUCCESS';
export const UPDATE_OVERDUE_PAYMENTS_FAIL = 'UPDATE_OVERDUE_PAYMENTS_FAIL';

// Gestión de ajustes/aumentos
export const CREATE_RENTAL_ADJUSTMENT_REQUEST = 'CREATE_RENTAL_ADJUSTMENT_REQUEST';
export const CREATE_RENTAL_ADJUSTMENT_SUCCESS = 'CREATE_RENTAL_ADJUSTMENT_SUCCESS';
export const CREATE_RENTAL_ADJUSTMENT_FAIL = 'CREATE_RENTAL_ADJUSTMENT_FAIL';

export const SIMULATE_RENTAL_ADJUSTMENT_REQUEST = 'SIMULATE_RENTAL_ADJUSTMENT_REQUEST';
export const SIMULATE_RENTAL_ADJUSTMENT_SUCCESS = 'SIMULATE_RENTAL_ADJUSTMENT_SUCCESS';
export const SIMULATE_RENTAL_ADJUSTMENT_FAIL = 'SIMULATE_RENTAL_ADJUSTMENT_FAIL';

export const FETCH_ADJUSTMENT_HISTORY_REQUEST = 'FETCH_ADJUSTMENT_HISTORY_REQUEST';
export const FETCH_ADJUSTMENT_HISTORY_SUCCESS = 'FETCH_ADJUSTMENT_HISTORY_SUCCESS';
export const FETCH_ADJUSTMENT_HISTORY_FAIL = 'FETCH_ADJUSTMENT_HISTORY_FAIL';

export const FETCH_UPCOMING_ADJUSTMENTS_REQUEST = 'FETCH_UPCOMING_ADJUSTMENTS_REQUEST';
export const FETCH_UPCOMING_ADJUSTMENTS_SUCCESS = 'FETCH_UPCOMING_ADJUSTMENTS_SUCCESS';
export const FETCH_UPCOMING_ADJUSTMENTS_FAIL = 'FETCH_UPCOMING_ADJUSTMENTS_FAIL';

export const NOTIFY_ADJUSTMENT_REQUEST = 'NOTIFY_ADJUSTMENT_REQUEST';
export const NOTIFY_ADJUSTMENT_SUCCESS = 'NOTIFY_ADJUSTMENT_SUCCESS';
export const NOTIFY_ADJUSTMENT_FAIL = 'NOTIFY_ADJUSTMENT_FAIL';

// Gestión de inquilinos
export const CREATE_RENTAL_TENANT_REQUEST = 'CREATE_RENTAL_TENANT_REQUEST';
export const CREATE_RENTAL_TENANT_SUCCESS = 'CREATE_RENTAL_TENANT_SUCCESS';
export const CREATE_RENTAL_TENANT_FAIL = 'CREATE_RENTAL_TENANT_FAIL';

export const FETCH_RENTAL_TENANTS_REQUEST = 'FETCH_RENTAL_TENANTS_REQUEST';
export const FETCH_RENTAL_TENANTS_SUCCESS = 'FETCH_RENTAL_TENANTS_SUCCESS';
export const FETCH_RENTAL_TENANTS_FAIL = 'FETCH_RENTAL_TENANTS_FAIL';

export const UPDATE_RENTAL_TENANT_REQUEST = 'UPDATE_RENTAL_TENANT_REQUEST';
export const UPDATE_RENTAL_TENANT_SUCCESS = 'UPDATE_RENTAL_TENANT_SUCCESS';
export const UPDATE_RENTAL_TENANT_FAIL = 'UPDATE_RENTAL_TENANT_FAIL';

export const DELETE_RENTAL_TENANT_REQUEST = 'DELETE_RENTAL_TENANT_REQUEST';
export const DELETE_RENTAL_TENANT_SUCCESS = 'DELETE_RENTAL_TENANT_SUCCESS';
export const DELETE_RENTAL_TENANT_FAIL = 'DELETE_RENTAL_TENANT_FAIL';

// Estados de loading y limpieza
export const CLEAR_RENTAL_STATE = 'CLEAR_RENTAL_STATE';
export const SET_RENTAL_LOADING = 'SET_RENTAL_LOADING';

// ================ ESTADÍSTICAS ACTION TYPES ================

// Módulo 1: Visitas Stats
export const FETCH_VISITAS_STATS_REQUEST = 'FETCH_VISITAS_STATS_REQUEST';
export const FETCH_VISITAS_STATS_SUCCESS = 'FETCH_VISITAS_STATS_SUCCESS';
export const FETCH_VISITAS_STATS_FAIL = 'FETCH_VISITAS_STATS_FAIL';

export const FETCH_VISITAS_STATS_PERIOD_REQUEST = 'FETCH_VISITAS_STATS_PERIOD_REQUEST';
export const FETCH_VISITAS_STATS_PERIOD_SUCCESS = 'FETCH_VISITAS_STATS_PERIOD_SUCCESS';
export const FETCH_VISITAS_STATS_PERIOD_FAIL = 'FETCH_VISITAS_STATS_PERIOD_FAIL';

// Módulo 2: Productividad Agentes
export const FETCH_SELLERS_STATS_REQUEST = 'FETCH_SELLERS_STATS_REQUEST';
export const FETCH_SELLERS_STATS_SUCCESS = 'FETCH_SELLERS_STATS_SUCCESS';
export const FETCH_SELLERS_STATS_FAIL = 'FETCH_SELLERS_STATS_FAIL';

// Módulo 3: Reuniones Individuales
export const FETCH_REUNIONES_RANKING_REQUEST = 'FETCH_REUNIONES_RANKING_REQUEST';
export const FETCH_REUNIONES_RANKING_SUCCESS = 'FETCH_REUNIONES_RANKING_SUCCESS';
export const FETCH_REUNIONES_RANKING_FAIL = 'FETCH_REUNIONES_RANKING_FAIL';

export const FETCH_REUNIONES_INFORME_REQUEST = 'FETCH_REUNIONES_INFORME_REQUEST';
export const FETCH_REUNIONES_INFORME_SUCCESS = 'FETCH_REUNIONES_INFORME_SUCCESS';
export const FETCH_REUNIONES_INFORME_FAIL = 'FETCH_REUNIONES_INFORME_FAIL';

export const FETCH_REUNIONES_TIPS_REQUEST = 'FETCH_REUNIONES_TIPS_REQUEST';
export const FETCH_REUNIONES_TIPS_SUCCESS = 'FETCH_REUNIONES_TIPS_SUCCESS';
export const FETCH_REUNIONES_TIPS_FAIL = 'FETCH_REUNIONES_TIPS_FAIL';

// Reuniones CRUD
export const CREATE_REUNION_REQUEST = 'CREATE_REUNION_REQUEST';
export const CREATE_REUNION_SUCCESS = 'CREATE_REUNION_SUCCESS';
export const CREATE_REUNION_FAIL = 'CREATE_REUNION_FAIL';

export const UPDATE_REUNION_REQUEST = 'UPDATE_REUNION_REQUEST';
export const UPDATE_REUNION_SUCCESS = 'UPDATE_REUNION_SUCCESS';
export const UPDATE_REUNION_FAIL = 'UPDATE_REUNION_FAIL';

export const DELETE_REUNION_REQUEST = 'DELETE_REUNION_REQUEST';
export const DELETE_REUNION_SUCCESS = 'DELETE_REUNION_SUCCESS';
export const DELETE_REUNION_FAIL = 'DELETE_REUNION_FAIL';

export const FETCH_REUNIONES_LIST_REQUEST = 'FETCH_REUNIONES_LIST_REQUEST';
export const FETCH_REUNIONES_LIST_SUCCESS = 'FETCH_REUNIONES_LIST_SUCCESS';
export const FETCH_REUNIONES_LIST_FAIL = 'FETCH_REUNIONES_LIST_FAIL';

export const FETCH_ACTIVE_SELLERS_REQUEST = 'FETCH_ACTIVE_SELLERS_REQUEST';
export const FETCH_ACTIVE_SELLERS_SUCCESS = 'FETCH_ACTIVE_SELLERS_SUCCESS';
export const FETCH_ACTIVE_SELLERS_FAIL = 'FETCH_ACTIVE_SELLERS_FAIL';

// Módulo 1b: Visitas por Agente
export const FETCH_VISITAS_AGENT_STATS_REQUEST = 'FETCH_VISITAS_AGENT_STATS_REQUEST';
export const FETCH_VISITAS_AGENT_STATS_SUCCESS = 'FETCH_VISITAS_AGENT_STATS_SUCCESS';
export const FETCH_VISITAS_AGENT_STATS_FAIL = 'FETCH_VISITAS_AGENT_STATS_FAIL';

export const CLEAR_ESTADISTICAS_STATE = 'CLEAR_ESTADISTICAS_STATE';

// ================ VISITAS EXTERNAS ACTION TYPES ================
export const CREATE_VISITA_EXTERNA_REQUEST = 'CREATE_VISITA_EXTERNA_REQUEST';
export const CREATE_VISITA_EXTERNA_SUCCESS = 'CREATE_VISITA_EXTERNA_SUCCESS';
export const CREATE_VISITA_EXTERNA_FAIL = 'CREATE_VISITA_EXTERNA_FAIL';

export const GET_VISITAS_EXTERNAS_REQUEST = 'GET_VISITAS_EXTERNAS_REQUEST';
export const GET_VISITAS_EXTERNAS_SUCCESS = 'GET_VISITAS_EXTERNAS_SUCCESS';
export const GET_VISITAS_EXTERNAS_FAIL = 'GET_VISITAS_EXTERNAS_FAIL';

export const GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST = 'GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST';
export const GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS = 'GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS';
export const GET_VISITAS_EXTERNAS_BY_AGENT_FAIL = 'GET_VISITAS_EXTERNAS_BY_AGENT_FAIL';

export const UPDATE_VISITA_EXTERNA_REQUEST = 'UPDATE_VISITA_EXTERNA_REQUEST';
export const UPDATE_VISITA_EXTERNA_SUCCESS = 'UPDATE_VISITA_EXTERNA_SUCCESS';
export const UPDATE_VISITA_EXTERNA_FAIL = 'UPDATE_VISITA_EXTERNA_FAIL';

export const DELETE_VISITA_EXTERNA_REQUEST = 'DELETE_VISITA_EXTERNA_REQUEST';
export const DELETE_VISITA_EXTERNA_SUCCESS = 'DELETE_VISITA_EXTERNA_SUCCESS';
export const DELETE_VISITA_EXTERNA_FAIL = 'DELETE_VISITA_EXTERNA_FAIL';

// Operaciones Externas (Punta Compradora)
export const CREATE_OPERACION_EXTERNA_REQUEST = 'CREATE_OPERACION_EXTERNA_REQUEST';
export const CREATE_OPERACION_EXTERNA_SUCCESS = 'CREATE_OPERACION_EXTERNA_SUCCESS';
export const CREATE_OPERACION_EXTERNA_FAIL = 'CREATE_OPERACION_EXTERNA_FAIL';

export const GET_OPERACIONES_EXTERNAS_REQUEST = 'GET_OPERACIONES_EXTERNAS_REQUEST';
export const GET_OPERACIONES_EXTERNAS_SUCCESS = 'GET_OPERACIONES_EXTERNAS_SUCCESS';
export const GET_OPERACIONES_EXTERNAS_FAIL = 'GET_OPERACIONES_EXTERNAS_FAIL';

export const GET_OPERACION_EXTERNA_BY_ID_REQUEST = 'GET_OPERACION_EXTERNA_BY_ID_REQUEST';
export const GET_OPERACION_EXTERNA_BY_ID_SUCCESS = 'GET_OPERACION_EXTERNA_BY_ID_SUCCESS';
export const GET_OPERACION_EXTERNA_BY_ID_FAIL = 'GET_OPERACION_EXTERNA_BY_ID_FAIL';

export const UPDATE_OPERACION_EXTERNA_REQUEST = 'UPDATE_OPERACION_EXTERNA_REQUEST';
export const UPDATE_OPERACION_EXTERNA_SUCCESS = 'UPDATE_OPERACION_EXTERNA_SUCCESS';
export const UPDATE_OPERACION_EXTERNA_FAIL = 'UPDATE_OPERACION_EXTERNA_FAIL';

export const DELETE_OPERACION_EXTERNA_REQUEST = 'DELETE_OPERACION_EXTERNA_REQUEST';
export const DELETE_OPERACION_EXTERNA_SUCCESS = 'DELETE_OPERACION_EXTERNA_SUCCESS';
export const DELETE_OPERACION_EXTERNA_FAIL = 'DELETE_OPERACION_EXTERNA_FAIL';

// Eventos avanzados (calendario mejorado + notificaciones)
export const FETCH_UPCOMING_EVENTS_REQUEST = 'FETCH_UPCOMING_EVENTS_REQUEST';
export const FETCH_UPCOMING_EVENTS_SUCCESS = 'FETCH_UPCOMING_EVENTS_SUCCESS';
export const FETCH_UPCOMING_EVENTS_FAIL = 'FETCH_UPCOMING_EVENTS_FAIL';

export const FETCH_EVENT_BY_ID_REQUEST = 'FETCH_EVENT_BY_ID_REQUEST';
export const FETCH_EVENT_BY_ID_SUCCESS = 'FETCH_EVENT_BY_ID_SUCCESS';
export const FETCH_EVENT_BY_ID_FAIL = 'FETCH_EVENT_BY_ID_FAIL';

export const MARK_EVENT_SEEN_REQUEST = 'MARK_EVENT_SEEN_REQUEST';
export const MARK_EVENT_SEEN_SUCCESS = 'MARK_EVENT_SEEN_SUCCESS';
export const MARK_EVENT_SEEN_FAIL = 'MARK_EVENT_SEEN_FAIL';

export const CHANGE_EVENT_STATUS_REQUEST = 'CHANGE_EVENT_STATUS_REQUEST';
export const CHANGE_EVENT_STATUS_SUCCESS = 'CHANGE_EVENT_STATUS_SUCCESS';
export const CHANGE_EVENT_STATUS_FAIL = 'CHANGE_EVENT_STATUS_FAIL';

// ================ PROPERTY VERSIONING & APPROVAL ACTION TYPES ================

// Versiones de propiedad
export const FETCH_PROPERTY_VERSIONS_REQUEST = 'FETCH_PROPERTY_VERSIONS_REQUEST';
export const FETCH_PROPERTY_VERSIONS_SUCCESS = 'FETCH_PROPERTY_VERSIONS_SUCCESS';
export const FETCH_PROPERTY_VERSIONS_FAIL = 'FETCH_PROPERTY_VERSIONS_FAIL';

export const REVERT_PROPERTY_VERSION_REQUEST = 'REVERT_PROPERTY_VERSION_REQUEST';
export const REVERT_PROPERTY_VERSION_SUCCESS = 'REVERT_PROPERTY_VERSION_SUCCESS';
export const REVERT_PROPERTY_VERSION_FAIL = 'REVERT_PROPERTY_VERSION_FAIL';

// Comentarios de propiedad
export const FETCH_PROPERTY_COMMENTS_REQUEST = 'FETCH_PROPERTY_COMMENTS_REQUEST';
export const FETCH_PROPERTY_COMMENTS_SUCCESS = 'FETCH_PROPERTY_COMMENTS_SUCCESS';
export const FETCH_PROPERTY_COMMENTS_FAIL = 'FETCH_PROPERTY_COMMENTS_FAIL';

export const ADD_PROPERTY_COMMENT_REQUEST = 'ADD_PROPERTY_COMMENT_REQUEST';
export const ADD_PROPERTY_COMMENT_SUCCESS = 'ADD_PROPERTY_COMMENT_SUCCESS';
export const ADD_PROPERTY_COMMENT_FAIL = 'ADD_PROPERTY_COMMENT_FAIL';

export const MARK_COMMENT_READ_SUCCESS = 'MARK_COMMENT_READ_SUCCESS';
export const MARK_COMMENT_READ_FAIL = 'MARK_COMMENT_READ_FAIL';

// Aprobación / Rechazo / Revisión
export const APPROVE_PROPERTY_REQUEST = 'APPROVE_PROPERTY_REQUEST';
export const APPROVE_PROPERTY_SUCCESS = 'APPROVE_PROPERTY_SUCCESS';
export const APPROVE_PROPERTY_FAIL = 'APPROVE_PROPERTY_FAIL';

export const REJECT_PROPERTY_REQUEST = 'REJECT_PROPERTY_REQUEST';
export const REJECT_PROPERTY_SUCCESS = 'REJECT_PROPERTY_SUCCESS';
export const REJECT_PROPERTY_FAIL = 'REJECT_PROPERTY_FAIL';

export const REQUEST_REVISION_REQUEST = 'REQUEST_REVISION_REQUEST';
export const REQUEST_REVISION_SUCCESS = 'REQUEST_REVISION_SUCCESS';
export const REQUEST_REVISION_FAIL = 'REQUEST_REVISION_FAIL';

// ================ ACM (Análisis Comparativo de Mercado) ================
export const CREATE_ACM_REQUEST = 'CREATE_ACM_REQUEST';
export const CREATE_ACM_SUCCESS = 'CREATE_ACM_SUCCESS';
export const CREATE_ACM_FAIL = 'CREATE_ACM_FAIL';

export const FETCH_ACMS_REQUEST = 'FETCH_ACMS_REQUEST';
export const FETCH_ACMS_SUCCESS = 'FETCH_ACMS_SUCCESS';
export const FETCH_ACMS_FAIL = 'FETCH_ACMS_FAIL';

export const FETCH_ACM_BY_ID_REQUEST = 'FETCH_ACM_BY_ID_REQUEST';
export const FETCH_ACM_BY_ID_SUCCESS = 'FETCH_ACM_BY_ID_SUCCESS';
export const FETCH_ACM_BY_ID_FAIL = 'FETCH_ACM_BY_ID_FAIL';

export const UPDATE_ACM_REQUEST = 'UPDATE_ACM_REQUEST';
export const UPDATE_ACM_SUCCESS = 'UPDATE_ACM_SUCCESS';
export const UPDATE_ACM_FAIL = 'UPDATE_ACM_FAIL';

export const DELETE_ACM_REQUEST = 'DELETE_ACM_REQUEST';
export const DELETE_ACM_SUCCESS = 'DELETE_ACM_SUCCESS';
export const DELETE_ACM_FAIL = 'DELETE_ACM_FAIL';

export const FETCH_ACM_VERSIONS_REQUEST = 'FETCH_ACM_VERSIONS_REQUEST';
export const FETCH_ACM_VERSIONS_SUCCESS = 'FETCH_ACM_VERSIONS_SUCCESS';
export const FETCH_ACM_VERSIONS_FAIL = 'FETCH_ACM_VERSIONS_FAIL';

export const REVERT_ACM_VERSION_REQUEST = 'REVERT_ACM_VERSION_REQUEST';
export const REVERT_ACM_VERSION_SUCCESS = 'REVERT_ACM_VERSION_SUCCESS';
export const REVERT_ACM_VERSION_FAIL = 'REVERT_ACM_VERSION_FAIL';

export const CLEAR_ACM_DETAIL = 'CLEAR_ACM_DETAIL';

